import { useCallback, useEffect, useState } from 'react';

// Fetch JSON from `url` whenever it changes (null = don't fetch). Responses with
// `success: false` count as errors unless keep(json) says that body is a normal answer.
// pick(json) chooses what to keep (default: the whole body). Returns { data, loading, error, reload }.
export default function useJson(url, pick = (json) => json, keep = () => false) {
  const [state, setState] = useState({ data: null, loading: !!url, error: null });
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    if (!url) {
      setState({ data: null, loading: false, error: null });
      return undefined;
    }
    let live = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    fetch(url)
      .then((res) => res.json())
      .then((json) => {
        if (!live) return;
        if (json && json.success === false && !keep(json)) {
          setState({ data: null, loading: false, error: json.error || json.message || 'Request failed.' });
        } else {
          setState({ data: pick(json), loading: false, error: null });
        }
      })
      .catch(() => live && setState({ data: null, loading: false, error: 'Request failed.' }));
    return () => { live = false; };
  // pick is expected to be stable in meaning; refetching follows the url only.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, tick]);

  return { ...state, reload };
}
